<template>
    <div>
        <loading
            :active.sync="loadingCard"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Verifikasi Data Diri</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" class="pb-2" v-if="loadingCard == false">
            <div v-if="status_verification == null">
                <div class="section inset mt-2">
                    <form>
                        <h3 style="font-weight:bold;">Lengkapi Data Diri</h3>
                        <p
                            class="text-justify"
                            style="font-size:11px;line-height: 15px;"
                        >
                            <b>PENTING!</b> Pastikan data diri yang Kamu
                            masukkan sudah benar sesuai dengan identitas yang
                            kamu miliki karena data tersebut akan di validasi di
                            sistem DUKCAPIL untuk memastikan kebenarannya
                        </p>
                        <hr style="margin-top:5px;" />
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label"
                                    >Nama Sesuai Identitas KTP</label
                                >
                                <input
                                    type="text"
                                    class="form-control text-capitalize"
                                    placeholder="Masukkan Nama Sesuai KTP"
                                    v-model="customer_verified_data.full_name"
                                    style="font-size:13px;"
                                />
                            </div>
                        </div>
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label"
                                    >Nomor Induk Kependudukan (NIK KTP)</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Masukkan Nomor Induk Kependudukan"
                                    v-model="
                                        customer_verified_data.no_identitas
                                    "
                                    style="font-size:13px;"
                                />
                            </div>
                        </div>
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Tempat Lahir</label>
                                <input
                                    type="text"
                                    class="form-control text-capitalize"
                                    v-model="customer_verified_data.birthplace"
                                    style="font-size:13px;"
                                />
                            </div>
                        </div>
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Tanggal Lahir</label>
                                <div class="row">
                                    <div class="col-4">
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                                customer_verified_data.birthdate
                                            "
                                            placeholder="Tanggal"
                                            style="font-size:13px;"
                                        />
                                    </div>
                                    <div class="col-4">
                                        <select
                                            name=""
                                            class="form-control"
                                            v-model="
                                                customer_verified_data.birthmonth
                                            "
                                            style="font-size:13px;padding:0px 15px 0px 10px;"
                                        >
                                            <option value="" disabled selected
                                                >- Bulan -</option
                                            >
                                            <option value="01">Januari</option>
                                            <option value="02">Februari</option>
                                            <option value="03">Maret</option>
                                            <option value="04">April</option>
                                            <option value="05">Mei</option>
                                            <option value="06">Juni</option>
                                            <option value="07">Juli</option>
                                            <option value="08">Agustus</option>
                                            <option value="09"
                                                >September</option
                                            >
                                            <option value="10">Oktober</option>
                                            <option value="11">November</option>
                                            <option value="12">Desember</option>
                                        </select>
                                    </div>
                                    <div class="col-4">
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                                customer_verified_data.birthyear
                                            "
                                            placeholder="Tahun"
                                            style="font-size:13px;"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Jenis Kelamin</label>
                                <div class="row">
                                    <div class="col-6">
                                        <div
                                            class="custom-control custom-radio"
                                        >
                                            <input
                                                type="radio"
                                                id="genderMale"
                                                name="gender"
                                                class="custom-control-input"
                                                v-model="
                                                    customer_verified_data.gender
                                                "
                                                value="L"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="genderMale"
                                                style="font-size:13px;"
                                                >Laki-Laki</label
                                            >
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div
                                            class="custom-control custom-radio"
                                        >
                                            <input
                                                type="radio"
                                                id="genderFemale"
                                                name="gender"
                                                class="custom-control-input"
                                                v-model="
                                                    customer_verified_data.gender
                                                "
                                                value="P"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="genderFemale"
                                                style="font-size:13px;"
                                                >Perempuan</label
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Input Provinsi -->
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Provinsi</label>
                                <select
                                    name=""
                                    class="form-control"
                                    v-model="
                                        customer_verified_data.provinces_id
                                    "
                                    style="font-size:13px;padding:0px 15px 0px 10px;"
                                    @change="changeProvinces($event)"
                                >
                                    <option value="" disabled selectd
                                        >- Pilih -</option
                                    >
                                    <option
                                        v-for="item in provinces"
                                        :value="item.province_code"
                                        :key="item.province_code"
                                        :data-name="item.province_name"
                                        >{{ item.province_name }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <!-- Input Kota/Kabupaten -->
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Kabupaten/Kota</label>
                                <select
                                    name=""
                                    class="form-control"
                                    v-model="
                                        customer_verified_data.regencies_id
                                    "
                                    style="font-size:13px;padding:0px 15px 0px 10px;"
                                    @change="changeRegencies($event)"
                                >
                                    <option value="" disabled selectd
                                        >- Pilih -</option
                                    >
                                    <option
                                        v-for="item in regencies"
                                        :value="item.regencie_code"
                                        :key="item.regencie_code"
                                        :data-name="item.regencie_name"
                                        >{{ item.regencie_name }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <!-- Input Kecamatan -->
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Kecamatan</label>
                                <select
                                    name=""
                                    class="form-control"
                                    v-model="
                                        customer_verified_data.districts_id
                                    "
                                    style="font-size:13px;padding:0px 15px 0px 10px;"
                                    @change="changeDistricts($event)"
                                >
                                    <option value="" disabled selectd
                                        >- Pilih -</option
                                    >
                                    <option
                                        v-for="item in districts"
                                        :value="item.district_code"
                                        :key="item.district_code"
                                        :data-name="item.district_name"
                                        >{{ item.district_name }}</option
                                    >
                                </select>
                            </div>
                        </div>
                        <!-- Input Kelurahan/Desa -->
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="label">Kelurahan</label>
                                <select
                                    name=""
                                    class="form-control"
                                    v-model="customer_verified_data.villages_id"
                                    style="font-size:13px;padding:0px 15px 0px 10px;"
                                    @change="changeVillages($event)"
                                >
                                    <option value="" disabled selectd
                                        >- Pilih -</option
                                    >
                                    <option
                                        v-for="item in villages"
                                        :value="item.village_code"
                                        :key="item.village_code"
                                        :data-name="item.village_name"
                                        >{{ item.village_name }}</option
                                    >
                                </select>
                            </div>
                        </div>
                    </form>
                    <!-- </div> -->
                </div>
                <div class="section inset mt-1">
                    <button
                        class="btn btn-primary btn-block btn-lg"
                        @click="showConfirmation('show')"
                    >
                        Simpan & Lanjutkan
                    </button>
                </div>
            </div>
            <div v-else-if="status_verification == 'WAITING'">
                <div class="section inset text-center">
                    <img
                        :src="require('@/assets/verification_waiting.png')"
                        alt="Verifikasi dalam proses"
                        class="w-50 mb-3"
                        style="margin-top:50px;"
                    /><br />
                    <h3>Dalam Proses Verifikasi</h3>
                    <p style="font-size: 12px;line-height: 150%;">
                        Waktu proses verifikasi data diri maksimal 1x24 jam
                        (tidak termasuk hari sabtu, minggu dan hari libur
                        nasional)
                    </p>
                    <!-- <div class="wide-block pt-2 pb-2 text-center">
                        <ion-icon name="sync-outline" style="font-size: 80px;color:#FF8C00;"></ion-icon>
                        <h2>Dalam Proses Verifikasi</h2>
                        <p>Proses verifikasi data diri maksimal 1x24 jam (tidak termasuk sabtu, minggu dan hari libur nasional)</p>
                    </div> -->
                </div>
            </div>
            <div v-else-if="status_verification == 'VERIFIED'">
                <div class="section inset text-center">
                    <img
                        :src="require('@/assets/verification_success.png')"
                        alt="Verifikasi dalam proses"
                        class="w-50 mb-3"
                        style="margin-top:50px;"
                    /><br />
                    <h3>Verifikasi Berhasil!</h3>
                    <p
                        style="font-size: 12px;line-height: 150%;margin-bottom: 5px;"
                    >
                        Selamat data diri Kamu sudah berhasil terverifikasi.
                    </p>
                </div>
                <!-- <div class="section inset mt-2">
                    <div class="wide-block pt-2 pb-2 text-center">
                        <ion-icon name="checkmark-circle" style="font-size: 80px;color:#00a65a;"></ion-icon>
                        <h2>Berhasil diverifikasi</h2>
                        <p>Selamat data diri anda telah berhasil diverifikasi.</p>
                    </div>
                </div> -->
            </div>
            <div v-else-if="status_verification == 'REJECTED'">
                <div class="section inset text-center">
                    <img
                        :src="require('@/assets/verification_rejected.png')"
                        alt="Verifikasi dalam proses"
                        class="w-50 mb-3"
                        style="margin-top:50px;"
                    /><br />
                    <h3>Verifikasi ditolak</h3>
                    <p
                        style="font-size: 12px;line-height: 150%;margin-bottom: 5px;"
                    >
                        Permintaan verifikasi data diri kamu belum dapat
                        diterima dengan alasan sebagai berikut :
                    </p>
                    <p
                        class="text-danger"
                        style="font-size: 14px;line-height: 150%;"
                    >
                        <b
                            ><i>{{ note_reject_verification }}</i></b
                        >
                    </p>
                    <button
                        class="btn btn-outline-primary btn-lg"
                        style="height:40px;border-width:1px;"
                        @click="status_verification = null"
                    >
                        Verifikasi Ulang
                    </button>
                </div>
            </div>
        </div>

        <action-sheet
            ref="modalConfirmation"
            :title="'Kebijakan Privasi'"
            :header="true"
            :inset="false"
            :content-height="false"
        >
            <privacy-policy></privacy-policy>
            <hr />
            <div class="text-center" style="font-size: 12px;line-height: 150%;">
                <p>
                    Dengan memilih tombol "<b>Ya, Setuju</b>" Anda telah
                    menyetujui <b>Kebijakan Privacy</b> dan
                    <b>Ketentuan Layanan</b> ini
                </p>
            </div>
            <div class="form-group basic pb-0">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-outline-primary btn-block btn-lg"
                            style="height:40px;border-width:1px;"
                            @click="showConfirmation('hide')"
                        >
                            Tidak
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="buttonLoadingModalConfirm"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            style="height:40px;"
                            @click.native="submit()"
                            >Ya, Setuju</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import $axios from './../../api.js';
    export default {
        name: 'account.data-diri',
        data() {
            return {
                loadingCard: false,
                dialogLoading: false,
                buttonLoadingModalConfirm: false,
                status_verification: null,
                note_reject_verification:
                    'Data yang dikirimkan belum sesuai ketentuan',
                customer_verified_data: {
                    full_name: '',
                    no_identitas: '',
                    birthplace: '',
                    birthdate: '',
                    birthmonth: '',
                    birthyear: '',
                    gender: '',
                    provinces_id: '',
                    provinces_name: '',
                    regencies_id: '',
                    regencies_name: '',
                    districts_id: '',
                    districts_name: '',
                    villages_id: '',
                    villages_name: '',
                },
            };
        },
        created() {
            this.loadingCard = true;
            this.getProvinces();
            this.getCustomer().then(response => {
                if (response.data.account_verified_data != null) {
                    if (
                        response.data.account_verified_data.status == 'APPROVED'
                    ) {
                        this.status_verification = 'VERIFIED';
                    } else if (
                        response.data.account_verified_data.status == 'PROCESS'
                    ) {
                        this.status_verification = 'WAITING';
                    } else if (
                        response.data.account_verified_data.status == 'REJECTED'
                    ) {
                        this.status_verification = 'REJECTED';
                        this.note_reject_verification =
                            response.data.account_verified_data.catatan;
                    }

                    this.customer_verified_data.full_name =
                        response.data.account_verified_data.full_name;
                    this.customer_verified_data.no_identitas =
                        response.data.account_verified_data.no_identitas;
                    this.customer_verified_data.birthplace =
                        response.data.account_verified_data.birthplace;
                    this.customer_verified_data.gender =
                        response.data.account_verified_data.gender;
                    if (response.data.account_verified_data.birthdate != null) {
                        let birthdate =
                            response.data.account_verified_data.birthdate;
                        this.customer_verified_data.birthdate = birthdate.split(
                            '-'
                        )[2];
                        this.customer_verified_data.birthmonth = birthdate.split(
                            '-'
                        )[1];
                        this.customer_verified_data.birthyear = birthdate.split(
                            '-'
                        )[0];
                    }

                    this.customer_verified_data.provinces_id =
                        response.data.account_verified_data.provinces_id;
                    this.customer_verified_data.provinces_name =
                        response.data.account_verified_data.provinces_name;
                    this.customer_verified_data.regencies_id =
                        response.data.account_verified_data.regencies_id;
                    this.customer_verified_data.regencies_name =
                        response.data.account_verified_data.regencies_name;
                    this.customer_verified_data.districts_id =
                        response.data.account_verified_data.districts_id;
                    this.customer_verified_data.districts_name =
                        response.data.account_verified_data.districts_name;
                    this.customer_verified_data.villages_id =
                        response.data.account_verified_data.villages_id;
                    this.customer_verified_data.villages_name =
                        response.data.account_verified_data.villages_name;

                    if (this.customer_verified_data.provinces_id) {
                        this.getRegencies(
                            this.customer_verified_data.provinces_id
                        ).then(() => {
                            this.getDistricts(
                                this.customer_verified_data.regencies_id
                            ).then(() => {
                                this.getVillages(
                                    this.customer_verified_data.districts_id
                                ).then(() => {
                                    this.loadingCard = false;
                                });
                            });
                        });
                    } else {
                        this.loadingCard = false;
                    }
                } else {
                    // cek apakah sudah melengkapi provifl atau tidak
                    if (this.customer.customer_detail) {
                        $axios.get('/customer/detail').then(response => {
                            this.customer_verified_data.full_name =
                                response.data.data.fullname;
                            this.customer_verified_data.gender =
                                response.data.data.gender;
                            console.log(response.data.birthDay);
                            this.customer_verified_data.birthdate =
                                response.data.data.birthDay;
                            this.customer_verified_data.birthmonth =
                                response.data.data.birthMonth;
                            this.customer_verified_data.birthyear =
                                response.data.data.birthYear;

                            this.loadingCard = false;
                        });
                    } else {
                        this.loadingCard = false;
                    }
                }
            });
            this.getProvinces();
        },
        computed: {
            ...mapState([
                'customer',
                'loading',
                'toast',
                'provinces',
                'regencies',
                'districts',
                'villages',
            ]),
        },
        methods: {
            ...mapActions([
                'getCustomer',
                'getProvinces',
                'getRegencies',
                'getDistricts',
                'getVillages',
            ]),
            ...mapMutations([
                'RESET_PROVINCES',
                'RESET_REGENCIES',
                'RESET_DISTRICTS',
                'RESET_VILLAGES',
            ]),
            showConfirmation(value) {
                let element = this.$refs.modalConfirmation.$el;
                window.$(element).modal(value);
            },
            submit() {
                this.$store.commit('RESET_TOAST');
                this.buttonLoadingModalConfirm = true;
                $axios
                    .post(
                        '/verification/first-step',
                        this.customer_verified_data
                    )
                    .then(response => {
                        this.showConfirmation('hide');
                        this.buttonLoadingModalConfirm = false;
                        this.$store.commit('SET_CUSTOMER', response.data.data);
                        if (
                            response.data.data.account_verified_data.status ==
                            'APPROVED'
                        ) {
                            this.status_verification = 'VERIFIED';
                        } else if (
                            response.data.data.account_verified_data.status ==
                            'PROCESS'
                        ) {
                            this.status_verification = 'WAITING';
                        } else {
                            if (
                                response.data.data.account_verified_data
                                    .status == 'REJECTED'
                            ) {
                                this.status_verification = 'REJECTED';
                            }

                            this.status_verification = null;
                            if (typeof window.AndroidNative !== 'undefined') {
                                window.AndroidNative.showFormVerification();
                                this.$router.push({ name: 'forward' });
                            } else {
                                this.$store.commit('SET_TOAST', {
                                    show: true,
                                    message:
                                        'Verifikasi selanjutnya hanya dapat dilakukan melalui Aplikasi Mobile',
                                    tipe: 'default',
                                    icon: 'warning',
                                });
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error.response);
                        if (error.response.status == 422) {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message:
                                    'Pastikan semua data yang diminta sudah diisi dengan benar',
                                tipe: 'default',
                                icon: 'danger',
                            });
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: error.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                        this.showConfirmation('hide');
                        this.buttonLoadingModalConfirm = false;
                    });
            },
            changeProvinces(event) {
                this.customer_verified_data.provinces_name = event.target.options[
                    event.target.options.selectedIndex
                ].getAttribute('data-name');
                this.customer_verified_data.regencies_id = '';
                this.customer_verified_data.regencies_name = '';
                this.customer_verified_data.districts_id = '';
                this.customer_verified_data.districts_name = '';
                this.customer_verified_data.villages_id = '';
                this.customer_verified_data.villages_name = '';
                this.RESET_REGENCIES();
                this.RESET_DISTRICTS();
                this.RESET_VILLAGES();
                this.getRegencies(this.customer_verified_data.provinces_id);
            },
            changeRegencies(event) {
                this.customer_verified_data.regencies_name = event.target.options[
                    event.target.options.selectedIndex
                ].getAttribute('data-name');
                this.customer_verified_data.districts_id = '';
                this.customer_verified_data.districts_name = '';
                this.customer_verified_data.villages_id = '';
                this.customer_verified_data.villages_name = '';
                this.RESET_DISTRICTS();
                this.RESET_VILLAGES();
                this.getDistricts(this.customer_verified_data.regencies_id);
            },
            changeDistricts(event) {
                this.customer_verified_data.districts_name = event.target.options[
                    event.target.options.selectedIndex
                ].getAttribute('data-name');
                this.customer_verified_data.villages_id = '';
                this.customer_verified_data.villages_name = '';
                this.RESET_VILLAGES();
                this.getVillages(this.customer_verified_data.districts_id);
            },
            changeVillages(event) {
                this.customer_verified_data.villages_name = event.target.options[
                    event.target.options.selectedIndex
                ].getAttribute('data-name');
            },
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
            this.RESET_PROVINCES();
            this.RESET_REGENCIES();
            this.RESET_DISTRICTS();
            this.RESET_VILLAGES();
        },
    };
</script>
